/*
  File: src/components/store/Pagination.jsx
  Purpose: Stateless pagination control with previous/next and page indicator.
  Props: { page: number, totalPages: number, onChange(nextPage: number) }
*/
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

/**
 * Pagination
 * Stateless pagination control.
 */
function Pagination({ page, totalPages, onChange }) {
    const canPrev = page > 1;
    const canNext = page < totalPages;
    return (
        <div className="flex justify-center mt-6">
            <div className="inline-flex items-center gap-3 px-3 py-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-md shadow-[0_0_30px_-10px_rgba(56,189,248,0.35)]">
                <button
                    disabled={!canPrev}
                    onClick={() => onChange(Math.max(1, page - 1))}
                    className={`w-9 h-9 inline-flex items-center justify-center rounded-full border ${!canPrev ? 'btn-disabled cursor-not-allowed border-white/10' : 'border-cyan-400/30 text-cyan-200/90 hover:bg-cyan-400/10 hover:shadow-[0_0_18px_rgba(34,211,238,0.4)]'}`}
                    aria-label="Previous page"
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <span className="text-sm text-white/80 min-w-[6ch] text-center select-none">
                    {page} / {totalPages}
                </span>
                <button
                    disabled={!canNext}
                    onClick={() => onChange(Math.min(totalPages, page + 1))}
                    className={`w-9 h-9 inline-flex items-center justify-center rounded-full border ${!canNext ? 'btn-disabled cursor-not-allowed border-white/10' : 'border-fuchsia-400/30 text-fuchsia-200/90 hover:bg-fuchsia-400/10 hover:shadow-[0_0_18px_rgba(217,70,239,0.4)]'}`}
                    aria-label="Next page"
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    );
}

export default Pagination;


